import { useCallback, useSyncExternalStore } from 'react';

import { appStore } from 'services/appStore';

type UseNotifyAdminSuccessReturn = {
  hasNotifiedAdmin: boolean;
  setHasNotifiedAdmin: (value: boolean) => void;
};

export const useNotifyAdminForQuotaSuccess = (): UseNotifyAdminSuccessReturn => {
  const hasNotifiedAdmin = useSyncExternalStore(
    appStore.subscribe,
    () => (appStore.getSettingsStorageValue('hasNotifiedAdminForQuota') as boolean) ?? false
  );

  const setHasNotifiedAdmin = useCallback((value: boolean) => {
    appStore.setSettingsStorageValue({ hasNotifiedAdminForQuota: value });
  }, []);

  return { hasNotifiedAdmin, setHasNotifiedAdmin };
};
